module.exports = __webpack_public_path__ + "static/media/Logomarca_negro.f4e2c4de.png";